export const rootLoader = () => {
  return null;
};
